module.exports = __webpack_public_path__ + "img/box65.f966c660.png";